import { render } from "./IconAngleDoubleUp.vue?vue&type=template&id=21d1c6ff"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__